module.exports = __webpack_public_path__ + "32ce6265c14f734498409b70b345731f.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarChloe3.png
// module id = 57
// module chunks = 0